<template>
  <i-select :filtrable="true" :value="value" class="select-contact" v-on="$listeners">
    <i-option-group
      v-for="contact in items"
      :key="contact.id"
      :label="`${contact.last_name} ${contact.first_name}`"
    >
      <i-option
        v-for="method in contact.contact_methods"
        :key="method.id"
        :value="method.id"
        :label="`${method.number_value} (${contact.last_name} ${contact.first_name})`"
      >
        <contact-method :item="method" />
      </i-option>
    </i-option-group>
  </i-select>
</template>

<script>
  import ContactMethod from '@pbx/components/contact-methods/item';
  import { ContactService } from '@pbx/services/ContactService';

  export default {
    components: { ContactMethod },
    props: {
      value: {
        type: [String, Number],
        default: null
      }
    },

    data: () => ({
      items: []
    }),

    created() {
      ContactService.getSelect().then(items => (this.items = items));
    }
  };
</script>

<style lang="scss">
  .select-contact {
    .ivu-select-group-wrap {
      border-bottom: 1px solid $grey;

      &:nth-last-child(1) {
        border-bottom: none;
      }
    }
  }
</style>
